/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rich_Faint_Mouse_MeltInputs */

const en_rich_faint_mouse_melt = /** @type {(inputs: Rich_Faint_Mouse_MeltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slug`)
};

const de_rich_faint_mouse_melt = /** @type {(inputs: Rich_Faint_Mouse_MeltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slug`)
};

/**
* | output |
* | --- |
* | "Slug" |
*
* @param {Rich_Faint_Mouse_MeltInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rich_faint_mouse_melt = /** @type {((inputs?: Rich_Faint_Mouse_MeltInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rich_Faint_Mouse_MeltInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rich_faint_mouse_melt(inputs)
	return de_rich_faint_mouse_melt(inputs)
});